module.exports = __webpack_public_path__ + "img/IMG_1627_Wood_MockedUp.953d9867.jpg";